import { useState } from "react";
import { CardHeader, Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from "reactstrap";
import { H3 } from "../../../../AbstractElements";
import { BestSellingProduct } from "../../../../Constant";

export const SellingProductHeader = () => {
const YearlyMonDropdown = ["Today", "Tommorow", "Yesterday"];

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen(!dropdownOpen);

  return (
    <CardHeader className="card-no-border pb-0">
      <div className="header-top">
        <H3>{BestSellingProduct}</H3>
        <div className="card-header-right-icon">
          <Dropdown isOpen={dropdownOpen} toggle={toggle}>
            <DropdownToggle caret color="light">Yearly</DropdownToggle>
            <DropdownMenu end>
              {YearlyMonDropdown.map((item, index) => (
                <DropdownItem key={index}>{item}</DropdownItem>
              ))}
            </DropdownMenu>
          </Dropdown>
        </div>
      </div>
    </CardHeader>
  );
};
